localStorage.removeItem('bundle_deal_expired');

document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'bundle_deal_start';

  const el = document.querySelector('.bundle-sale-timer');
  if (!el) return;

  const durationMs = parseInt(el.dataset.timerDuration || '15', 10) * 60 * 1000;

  const hhEl = el.querySelector('.bundle-sale-timer__hh');
  const mmEl = el.querySelector('.bundle-sale-timer__mm');
  const ssEl = el.querySelector('.bundle-sale-timer__ss');

  const pad2 = (n) => String(n).padStart(2, '0');

  function updateDisplay(remaining) {
    const totalSec = Math.floor(remaining / 1000);
    hhEl.textContent = pad2(Math.floor(totalSec / 3600));
    mmEl.textContent = pad2(Math.floor((totalSec % 3600) / 60));
    ssEl.textContent = pad2(totalSec % 60);
  }

  const sectionEl = el.parentElement;
  const elHeight = el.offsetHeight;
  const triggerOffset = el.getBoundingClientRect().top + window.scrollY;

  function applySticky() {
    el.classList.add('bundle-sale-timer--sticky');
    sectionEl.style.minHeight = elHeight + 'px';
  }

  function removeSticky() {
    el.classList.remove('bundle-sale-timer--sticky');
    sectionEl.style.minHeight = '';
  }

  function onScroll() {
    if (window.scrollY >= triggerOffset) {
      applySticky();
    } else {
      removeSticky();
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  let intervalId;

  function startTimer() {
    const startTime = String(Date.now());
    localStorage.setItem(STORAGE_KEY, startTime);
    const endTime = parseInt(startTime, 10) + durationMs;

    updateDisplay(durationMs);

    intervalId = setInterval(() => {
      const rem = Math.max(0, endTime - Date.now());
      updateDisplay(rem);
      if (rem === 0) {
        clearInterval(intervalId);
        startTimer();
      }
    }, 1000);
  }

  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    const endTime = parseInt(stored, 10) + durationMs;
    const remaining = endTime - Date.now();

    if (remaining > 0) {
      updateDisplay(remaining);
      intervalId = setInterval(() => {
        const rem = Math.max(0, endTime - Date.now());
        updateDisplay(rem);
        if (rem === 0) {
          clearInterval(intervalId);
          startTimer();
        }
      }, 1000);
    } else {
      startTimer();
    }
  } else {
    startTimer();
  }
});
